import React from "react";
import { useDispatch } from "react-redux";

const FilterCard = ({ filter, filterAction }) => {
  const dispatch = useDispatch();
  return (
    <div className='flex bg-orange-600 text-white my-3 px-3 py-1 gap-2 rounded-full '>
      <p>{filter}</p>
      <span onClick={() => dispatch(filterAction(filter))} className='material-icons cursor-pointer'>
        close
      </span>
    </div>
  );
};

export default FilterCard;
